import { Scrollable } from '@rematter/ui-web';
import { LucideFrown } from 'lucide-react';

import { InventoryItemsModalItemsGrid } from '../InventoryItemsModal/InventoryItemsModalItemsGrid';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';
import { InventoryItemRecord } from '~/modules/trade/types/load';

export type CatalyticConverterRootViewProps = {
  effectiveColorScheme: 'light' | 'dark';
  searchTerm: string;
  noResultsFound: boolean;
  catalyticItems: InventoryItemRecord[];
  catalyticSearchResults: InventoryItemRecord[];
  selectedItemId?: string | null;
  onSelectItem: (itemId: string) => void;
};

export const CatalyticConverterRootView = ({
  effectiveColorScheme,
  searchTerm,
  noResultsFound,
  catalyticItems,
  catalyticSearchResults,
  selectedItemId,
  onSelectItem,
}: CatalyticConverterRootViewProps) => {
  const t = useTranslations();

  const hasSearchResults =
    searchTerm.length > 0 && catalyticSearchResults.length > 0;

  const itemsToDisplay = hasSearchResults
    ? catalyticSearchResults
    : catalyticItems;

  return (
    <Scrollable
      themeMode={effectiveColorScheme}
      className="@CatalyticConverterRootView"
    >
      <div className="flex flex-col gap-6">
        {noResultsFound && (
          <>
            <div className="flex items-center justify-center gap-3 px-3.5 py-5">
              <LucideFrown size={28} className="text-neutral opacity-30" />
              <span className="font-medium text-neutral/40">
                {t.inventoryItemsModal.noResultsFound}
              </span>
            </div>
            <hr className="m-0 border border-neutral/20" />
          </>
        )}

        {!noResultsFound && (
          <InventoryItemsModalItemsGrid
            items={itemsToDisplay}
            selectedId={selectedItemId}
            onSelectItem={onSelectItem}
          />
        )}
      </div>
    </Scrollable>
  );
};
